import { render } from "./WalletConnector.vue?vue&type=template&id=acb2ea3a&scoped=true"
import script from "./WalletConnector.vue?vue&type=script&lang=js"
export * from "./WalletConnector.vue?vue&type=script&lang=js"

import "./WalletConnector.vue?vue&type=style&index=0&id=acb2ea3a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-acb2ea3a"

export default script